import React, { memo } from "react";
import PropTypes from "prop-types";
import { WarningRoot } from "./elements";

export const BettoWithdrawWarning = memo(({ children }) => (
	<WarningRoot>{children}</WarningRoot>
));

BettoWithdrawWarning.displayName = "BettoWithdrawWarning";

BettoWithdrawWarning.propTypes = {
	children: PropTypes.node,
};
